import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("aw4wZ"), parcelRequire.load("3bSKP"), parcelRequire.load("G6uoA"), parcelRequire.load("h3ESC"), parcelRequire.load("blC0m"), parcelRequire.load("ecLgm"), parcelRequire.load("kTb4A"), parcelRequire.load("5YCil")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aw4wZ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3bSKP")} />
  <link rel="modulepreload" href={parcelRequire.resolve("G6uoA")} />
  <link rel="modulepreload" href={parcelRequire.resolve("h3ESC")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
  <link rel="modulepreload" href={parcelRequire.resolve("ecLgm")} />
  <link rel="modulepreload" href={parcelRequire.resolve("kTb4A")} />
  <link rel="modulepreload" href={parcelRequire.resolve("5YCil")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
